"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3RequestCanceledMessage = void 0;
const RelayMessage_1 = require("./RelayMessage");
function Web3RequestCanceledMessage(id) {
    return { type: RelayMessage_1.RelayMessageType.WEB3_REQUEST_CANCELED, id };
}
exports.Web3RequestCanceledMessage = Web3RequestCanceledMessage;
